export default __webpack_public_path__ + "static/media/miscolle.e4c4467d.svg";